export default __webpack_public_path__ + "static/media/blog-7.354285e0.jpg";